// extracted by mini-css-extract-plugin
export default {"cutoff":"Cutoff_cutoff__6ZXG3"};